import {
  greenWallet,
  orangeCoin,
  orangeGrowth,
  purpleGrowth,
} from "@/common/components/icons/svg-icons";

export const accountantFinancialsCards = [
  {
    id: 1,
    name: "DRF Balance",
    value: 20000,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Recent Fund Allocation",
    value: 120000,
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Total Allocations",
    value: 120000,
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    name: "Total Request Submitted",
    value: 30,
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const accountantFinancialsTableHeaders = [
  "Month",
  "Total Sale",
  "Sale Revenue",
  "Restocking Cost",
  "Net Balance",
];

export const accountantFinancialsTableKeys = [
  "month",
  "total_sales",
  "sales_revenue",
  "restocking_cost",
  "net_balance",
];

export const getAccountantFinancialsTableData = () => {
  return new Array(10).fill(0).map((_, index: number) => ({
    id: `${index}`,
    month: { value: "January", type: "string" },
    total_sales: { value: "4200", type: "string" },
    sales_revenue: { value: "1050000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "450000", type: "string" },
  }));
};

export const accountantAuditTableHeaders = [
  "Date",
  "Time",
  "User",
  "Action",
  "Details",
];

export const accountantAuditTableKeys = [
  "date",
  "time",
  "user",
  "action",
  "details",
];

export const getAccountantAuditTableData = () => {
  return new Array(10).fill(0).map((_, index: number) => ({
    id: `${index}`,
    date: { value: "10-10-2025", type: "string" },
    time: { value: "10:24", type: "string" },
    user: { value: "Ahmed Bello", type: "string" },
    action: { value: "sales", type: "string" },
    details: {
      value: "Sold 50 Units of Amoxicillin at N100 each",
      type: "string",
    },
  }));
};
